import { ImportantInfoCard } from "./importantInfoCard.component";
import { DocumentsListCard } from "./documentListCard.component";
import { ApiSchemaCompany } from "../../../models/api/company";

type Props = {
  data: ApiSchemaCompany | undefined;
  isValidating: boolean;
};

export const CompanyInformation = (props: Props) => (
  <div className="row gx-0 g-lg-2 g-md-2">
    <div className="col-md-6 col-12 mb-3 ">
      <ImportantInfoCard {...props} />
    </div>
    <div className="col-md-6 col-12 mb-1">
      <DocumentsListCard {...props} />
    </div>
  </div>
);
